import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

// Paleta RagnameX — Alternate Dimension
// Base navy profundo + acentos dorados (ornamentación) y azules (brillo/energía)
export default new Vuetify({
  theme: {
    dark: true,
    themes: {
      light: {
        primary: '#4a7fe0',    // Azul RagnameX (botones principales, brillo del logo)
        secondary: '#0a1428',  // Navy profundo (fondos, header)
        accent: '#d9ac5c',     // Dorado (bordes ornamentales, acentos)
        error: '#e0563f',      // Rojo
        info: '#4a7fe0',       // Azul
        success: '#3ecf6c',    // Verde (estado "Online")
        warning: '#d9ac5c',    // Dorado
        background: '#0a1428', // Fondo base navy (evita el gris por defecto de Vuetify)
        surface: '#101c33',    // v-sheet / v-card / v-menu / v-app-bar
      },
      dark: {
        primary: '#4a7fe0',    // Azul RagnameX
        secondary: '#0d1b2f',  // Navy oscuro (paneles, header)
        accent: '#d9ac5c',     // Dorado
        error: '#e0563f',      // Rojo
        info: '#4a7fe0',       // Azul
        success: '#3ecf6c',    // Verde (estado "Online")
        warning: '#d9ac5c',    // Dorado
        background: '#060b18', // Fondo base navy (evita el #121212 por defecto de Vuetify)
        surface: '#101c33',    // v-sheet / v-card / v-menu / v-app-bar
      },
    },
  },
});